import { Layout, Menu } from '@nackle/paper';
import { GridCross, Cube, BillDollar } from '@nackle/icons';
import { getDelegatedOrCurrentCompanyId } from 'app/dux/session/selectors';
import { HeaderButtonLink } from 'components/header/HeaderButtonLink';
import { NavLinkDefinition } from 'components/header/NavLinkDefinition';
import React from 'react';
import { useSelector } from 'react-redux';
import { ARCADES_PATH, COMPANY_PATH, ROMS_PATH, TOKENS_PATH, TOKENS_PATH_LIST } from 'routes/paths';
import { render } from 'enzyme';

import './header.less';

const { Header } = Layout;

const mainLinks: NavLinkDefinition[] = [
    { id: 'arcades-link', path: ARCADES_PATH, label: 'Arcades', icon: <GridCross/>},
    { id: 'games-link', path: ROMS_PATH, label: 'ROMs', icon: <Cube/> },
    { id: 'tokens-link', path: TOKENS_PATH+TOKENS_PATH_LIST, label: 'Tokens', icon: <BillDollar/>},
];

export default function Headers() {
    const companyId = useSelector(getDelegatedOrCurrentCompanyId);

    const parentPath = COMPANY_PATH.replace(':companyId', companyId);

    const navLinks = () => {
        const links = mainLinks.map((link) => {
            render(
                <HeaderButtonLink key={link.path} link={link} parentPath={parentPath} />
            );
        });
        return <>{links}</>;
    };

    return (
        <Layout className="header-layout">
            <Header key="nav" className="content">
                <Menu theme="light" mode="horizontal" key="nav">
                    {mainLinks.map((link) => {
                        return <HeaderButtonLink key={link.path} link={link} parentPath={parentPath} />;
                    })}
                    {navLinks}
                </Menu>
            </Header>
        </Layout>
    );
}
